var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    _vm._b(
      {
        attrs: {
          "max-width": "500px",
          persistent: "",
          "disable-close": _vm.loading,
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v("\n    Merge Existing Vegetative Plot Into Alias\n  "),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("p", [
                  _vm._v(
                    "Merge a vegetative plot into this location. The selected plot's aliases, specimen, and surveys will be moved\n      to this location."
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Note:")]),
                  _vm._v(
                    " Vegetative plot that contain non-primary aliases cannot be merged. Please separate\n      the non-primary aliases then merge each alias into this plot."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "v-form",
                  {
                    ref: "form",
                    model: {
                      value: _vm.formIsValid,
                      callback: function ($$v) {
                        _vm.formIsValid = $$v
                      },
                      expression: "formIsValid",
                    },
                  },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        rules: [
                          ..._vm.plotToBeMergedFormField.rules,
                          _vm._samePlotTypeRule,
                          _vm._sameCommunityTypeRule,
                        ],
                        required: "",
                        label: "Vegetative Plot to merge",
                        items: _vm.plotsEligibleForMerge,
                        "item-text": "PrimaryName",
                        "item-value": "Id",
                        "return-object": "",
                        disabled: _vm.loading,
                      },
                      model: {
                        value: _vm.plotToBeMergedFormField.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.plotToBeMergedFormField, "value", $$v)
                        },
                        expression: "plotToBeMergedFormField.value",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-spacer"),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "secondary--text font-italic" },
                      [
                        _vm._v("Why can't I select a certain plot? "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function ($event) {
                                _vm.showPlotFilterInfo = !_vm.showPlotFilterInfo
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("info")])],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-expand-transition", [
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPlotFilterInfo,
                              expression: "showPlotFilterInfo",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "\n          Not every plot is compatible for merging. Eligible plots must have only one synonym, not have\n          any nested plots, have the same plot type as the current plot, and have the same community type as the\n          current plot.\n        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("v-checkbox", {
                      attrs: {
                        color: "error",
                        label: "Test Run",
                        "persistent-hint": "",
                        hint: "See logs of the outcome without making any changes",
                        disabled: _vm.loading,
                      },
                      model: {
                        value: _vm.assignOptions.isTestRun,
                        callback: function ($$v) {
                          _vm.$set(_vm.assignOptions, "isTestRun", $$v)
                        },
                        expression: "assignOptions.isTestRun",
                      },
                    }),
                    _vm._v(" "),
                    _vm.isSystemAdmin
                      ? [
                          _c("v-subheader", { staticClass: "pl-0 mt-2" }, [
                            _vm._v("System Administrator Settings"),
                          ]),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: {
                              color: "info",
                              label: "Make primary name",
                              "persistent-hint": "",
                              hint: "New synonym will become the primary name",
                              disabled: _vm.loading,
                            },
                            model: {
                              value: _vm.assignOptions.makePrimary,
                              callback: function ($$v) {
                                _vm.$set(_vm.assignOptions, "makePrimary", $$v)
                              },
                              expression: "assignOptions.makePrimary",
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "v-expand-transition",
                  [
                    _c(
                      "v-alert",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.assignOptions.makePrimary,
                            expression: "assignOptions.makePrimary",
                          },
                        ],
                        key: "alert",
                        staticClass: "my-0",
                        attrs: {
                          outline: "",
                          type: "warning",
                          value: _vm.assignOptions.makePrimary,
                        },
                      },
                      [
                        _c("div", { staticClass: "primary--text" }, [
                          _vm._v(
                            "\n          The primary alias name shows up in reports, which may cause confusion when the primary alias does not match\n          the location name.\n        "
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("ExecutionResultsDialog", {
                  ref: "executionResultsDialog",
                  attrs: {
                    title: "Move Data Source",
                    shouldClose: !_vm.assignOptions.isTestRun,
                  },
                  on: {
                    close: function ($event) {
                      return _vm.close()
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "success",
                      loading: _vm.loading,
                      disabled: !_vm.formIsValid,
                    },
                    on: { click: _vm.submit },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(" " + _vm._s(_vm.$t("Button.Save")) + "\n    "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      outline: "",
                      color: "secondary",
                      disalbed: _vm.loading,
                    },
                    on: { click: _vm.close },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      },
      "AppModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }